import React, {useState, useRef, useEffect} from "react";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {Toast} from "primereact/toast";
import Spinner from "../../spinner/Spinner";
import {TabPanel, TabView} from "primereact/tabview";
import {Column} from "primereact/column";
import {DataTable} from "primereact/datatable";
import {Tooltip} from "primereact/tooltip";
import {Button} from "primereact/button";
import {Tag} from "primereact/tag";
import {Dialog} from "primereact/dialog";
import {InputNumber} from "primereact/inputnumber";
import {Divider} from "primereact/divider";
import {InputTextarea} from "primereact/inputtextarea";
import {InputText} from "primereact/inputtext";


const CreditApplications = props => {
    const toast = useRef(null);
    const credit_approver_role = localStorage.getItem("credit_approver") ? true : false;
    const [loadingState, setLoadingState] = useState(false);
    const [applications, setApplications] = useState([]);
    const [pendingApplications, setPendingApplications] = useState([]);
    const [approvedApplications, setApprovedApplications] = useState([]);
    const [acceptDialog, setAcceptDialog] = useState(false);
    const [rejectDialog, setRejectDialog] = useState(false);
    const [appliedCredit, setAppliedCredit] = useState(0);
    const [applicationID, setApplicationID] = useState(null);
    const [cpuLimit, setCpuLimit] = useState(0);
    const [gpuLimit, setGpuLimit] = useState(0);
    const [ramLimit, setRamLimit] = useState(0);
    const [diskLimit, setDiskLimit] = useState(0);
    const [creditAcceptedDescription, setCreditAcceptedDescription] = useState("");
    const [creditRejectedDescription, setCreditRejectedDescription] = useState("");
    const [descriptionDialog, setDescriptionDialog] = useState(false);
    const [descriptionDialogHeader, setDescriptionDialogHeader] = useState("");
    const [descriptionDialogContent, setDescriptionDialogContent] = useState("");
    const [activeIndex, setActiveIndex] = useState(0);
    const [globalFilter1, setGlobalFilter1] = useState('');


    useEffect(() => {
        getApplications();
    }, []);

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const approve_credit = () => {

        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");

        if (token) {
            headers["Authorization"] = `Token ${token}`;

            if (cpuLimit < 1) {
                showError("CPU Limiti En az 1 Olmalıdır");
                return;
            }
            if (ramLimit < 2) {
                showError("RAM Limiti En az 2 GB Olmalıdır");
                return;
            }
            if (diskLimit < 1) {
                showError("DİSK Limiti En az 1 GB Olmalıdır");
                return;
            }
            const data = {
                "application_id": applicationID,
                "applied_credit": appliedCredit,
                "cpu_limit": cpuLimit,
                "gpu_limit": gpuLimit,
                "ram_limit": ramLimit,
                "disk_limit": diskLimit,
                "accepted_description": creditAcceptedDescription
            };
            const body = JSON.stringify(data);
            fetch("/api/credit-application-admin/accept", {headers, method: "POST", body})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;

                        if (data.result) {
                            setAcceptDialog(false);
                            setCreditAcceptedDescription('');
                            getApplications();
                            showSuccess(data.message);
                        } else {
                            showError(data.message);
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })
        }


    }

    const reject_credit = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");

        if (token) {
            headers["Authorization"] = `Token ${token}`;

            if (creditRejectedDescription === null || creditRejectedDescription.length < 3) {
                showError("Lütfen Kredi İptal Açıklaması Kısmını Doldurunuz!");
                return;
            }

            const data = {
                "application_id": applicationID,
                "rejected_description": creditRejectedDescription
            };
            const body = JSON.stringify(data);
            fetch("/api/credit-application-admin/reject", {headers, method: "POST", body})
                .then(res => {
                    if (res.status < 500) {
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        const data = res.data;

                        if (data.result) {
                            setRejectDialog(false);
                            setCreditRejectedDescription('');
                            getApplications();
                            showSuccess(data.message);
                        } else {
                            showError(data.message);
                            // this.setState({disable_submit_btn: false});
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        throw res.data;

                    } else if (res.status === 403) {
                        throw res.data;

                    }
                })
        }
    }

    const getApplications = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/credit-application-admin/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            let apps = Array();
                            let approved_apps = Array();
                            let pending_apps = Array();
                            data.applications.map((app) => {
                                if (app.sact_id === 1) {
                                    pending_apps.push(app);
                                } else if (app.sact_id === 2) {
                                    approved_apps.push(app);
                                }
                                apps.push(app);
                            });
                            setPendingApplications(pending_apps);
                            setApprovedApplications(approved_apps);
                            setApplications(apps);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getUserCreditLimits = (user_id) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        const data = {
            "user_id": user_id
        }
        if (token) {
            setLoadingState(true);
            const body = JSON.stringify(data);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/credit-limits/", {headers, method: "POST", body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setCpuLimit(data["limits"]["cpu_limit"]);
                            setGpuLimit(data["limits"]["gpu_limit"]);
                            setRamLimit(data["limits"]["ram_limit"]);
                            setDiskLimit(data["limits"]["disk_limit"]);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const getApplicationBody = (compute_key, compute_name) => {
        const applicationBody = (rowData) => {
            return (
                <React.Fragment>
                    <div>
                        <div className="p-grid">
                            <div className="p-col-12" >
                                <span className="p-column-title">{compute_name}</span>
                            </div>
                            <div className="p-col-12" style={{wordBreak: "break-all"}}>
                                {rowData[compute_key] ? rowData[compute_key] : <span>-</span>}
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return applicationBody;
    }

    const getInstBody = (compute_key, compute_name) => {
        const instutionBody = (rowData) => {
            return (
                <React.Fragment>
                    <di>
                        <div className="p-grid">
                            <div className="p-col-12">
                                <span className="p-column-title">{compute_name}</span>
                            </div>
                            <div className="p-col-12" >
                                {rowData[compute_key] ? rowData[compute_key] : <span>-</span>}
                            </div>
                        </div>
                    </di>

                </React.Fragment>
            );
        }
        return instutionBody;
    }

    const processBody = (rowData) => {
        return (
            <React.Fragment>
                <div >
                    <div className="p-grid">
                        <div className="p-col-12" >
                            <span className="p-column-title">İŞLEVLER</span>
                        </div>
                        <div className="p-col-12" >
                            <Button icon="pi pi-check"
                                    className="p-button-success p-mr-2"
                                    onClick={(e) => acceptDialogDisplay(rowData.id, rowData.user_id, rowData.requested_credit)}
                                    tooltip="Kredi Onayla"
                                    tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                            />
                            <Button icon="pi pi-times"
                                    className="p-button-danger"
                                    onClick={(e) => rejectDialogDisplay(rowData.id)}
                                    tooltip="Kredi İptal Et"
                                    tooltipOptions={{position: 'bottom', mouseTrack: true, mouseTrackTop: 15}}
                            />
                        </div>
                    </div>
                </div>

            </React.Fragment>
        );
    }

    const getHeader = (value) => {
        return (
            <div align="center" style={{wordBreak: 'break-all'}}>{value}</div>
        );
    }

    const acceptDialogDisplay = (application_id, user_id, requested_credit) => {
        setApplicationID(application_id);
        getUserCreditLimits(user_id);
        setAppliedCredit(requested_credit);
        setAcceptDialog(true);
    }

    const acceptDialogOnHide = () => {
        setAcceptDialog(false);
        setCreditAcceptedDescription('');
    }

    const rejectDialogDisplay = (application_id) => {
        setApplicationID(application_id);
        setRejectDialog(true);
    }

    const rejectDialogOnHide = () => {
        setRejectDialog(false);
        setCreditRejectedDescription('');
    }

    const descriptionDialogOnDisplay = (header, content) => {
        setDescriptionDialogHeader(header);
        setDescriptionDialogContent(content);
        setDescriptionDialog(true);
    }

    const descriptionDialogOnHide = () => {
        setDescriptionDialogHeader("");
        setDescriptionDialogContent("");
        setDescriptionDialog(false);
    }

    const getDescriptionBody = (key, title) => {
        const descriptionBody = (rowData) => {
            return (
                <React.Fragment>
                    <div align="center">
                        <div className="p-grid">
                            <div className="p-col-12" align="center">
                                <span className="p-column-title">{title}</span>
                            </div>
                            <div className="p-col-12" align="center" style={{wordBreak: "break-all"}}>
                                {rowData[key]
                                    ?
                                    rowData[key].length > 20
                                        ?
                                        <div>
                                            {rowData[key].substring(0, 20) + "..."}
                                            <Button label="Devamını Oku"
                                                    onClick={(e) => descriptionDialogOnDisplay(title, rowData[key])}
                                                    className="p-button-text"
                                            />
                                        </div>
                                        :
                                        rowData[key]
                                    :
                                    <span>-</span>
                                }
                            </div>
                        </div>
                    </div>

                </React.Fragment>
            );
        }
        return descriptionBody;
    }

    const customer1TableHeader = (
        <div className="table-header" align="right">

            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)}
                           placeholder="Genel Arama"/>
            </span>
        </div>
    );

    const actionTemplate = (rowData) => {
        let status = rowData.sact_id
        if (status === 1) {
            return <div>
                <React.Fragment>


                    <Tag className="mr-2" severity="warning" value="Onay Bekliyor" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === 2) {
            return <div>
                <React.Fragment>

                    <Tag className="mr-2" severity="success" value="Onaylanmış" rounded/>


                </React.Fragment>


            </div>;

        } else if (status === 3) {
            return <div>
                <React.Fragment>


                    <Tag severity="danger" value="İptal Edilmiş" rounded/>


                </React.Fragment>


            </div>;

        }

    }

    if (credit_approver_role) {
        return (
            <div className='p-fluid'>
                <Toast ref={toast}/>
                <Spinner loadingState={loadingState}/>
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                    <TabPanel header="Tümü">
                        <div className="datatable-responsive-demo">
                            <div className='card'>
                                <DataTable
                                    value={applications}
                                    className='p-datatable-responsive-demo'
                                    paginator rows={10}
                                    emptyMessage="Kayıt Bulunamadı"
                                    globalFilter={globalFilter1}
                                    header={customer1TableHeader}
                                >
                                    <Column
                                        field={'sact_id'}
                                        header="Durum"
                                        body={actionTemplate}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'user_name'}
                                        header="Kullanıcı Adı"
                                        body={getApplicationBody("user_name", "Kullanıcı Adı")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'user_inst'}
                                        header="Kurumu"
                                        body={getInstBody("user_inst", "Kurumu")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'reason'}
                                        header="Talep Açıklaması"
                                        body={getDescriptionBody("reason", "Talep Açıklaması")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'application_time'}
                                        header="Başvuru Zamanı"
                                        body={getApplicationBody("application_time", "Başvuru Zamanı")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'requested_credit'}
                                        header="Talep Edilen Kredi"
                                        body={getApplicationBody("requested_credit", "Talep Edilen Kredi")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'available_credit'}
                                        header="Mevcut Kredi"
                                        body={getApplicationBody("available_credit", "Mevcut Kredi")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field="controller"
                                        header="Onaylayan"
                                        style={{textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'control_description'}
                                        header="Kontrol Açıklaması"
                                        body={getApplicationBody("control_description", "Kontrol Açıklaması")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    />

                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header="Onaylanmış Kredi Talepleri">
                        <div className="datatable-responsive-demo">
                            <div className='card'>
                                <DataTable
                                    value={approvedApplications}
                                    className='p-datatable-responsive-demo'
                                    paginator rows={10}
                                    emptyMessage="Kayıt Bulunamadı"
                                    globalFilter={globalFilter1}
                                    header={customer1TableHeader}
                                >
                                    <Column
                                        field={'sact_id'}
                                        header="Durum"
                                        body={actionTemplate}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}

                                    />
                                    <Column
                                        field={'user_name'}
                                        header="Kullanıcı Adı"
                                        body={getApplicationBody("user_name", "Kullanıcı Adı")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'user_inst'}
                                        header="Kurumu"
                                        body={getInstBody("user_inst", "Kurumu")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'reason'}
                                        header="Talep Açıklaması"
                                        body={getDescriptionBody("reason", "Talep Açıklaması")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'application_time'}
                                        header="Başvuru Zamanı"
                                        body={getApplicationBody("application_time", "Başvuru Zamanı")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'requested_credit'}
                                        header="Talep Edilen Kredi"
                                        body={getApplicationBody("requested_credit", "Talep Edilen Kredi")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'available_credit'}
                                        header="Mevcut Kredi"
                                        body={getApplicationBody("available_credit", "Mevcut Kredi")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field="controller"
                                        header="Onaylayan"
                                        style={{textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'control_description'}
                                        header="Kontrol Açıklaması"
                                        body={getApplicationBody("control_description", "Kontrol Açıklaması")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    />
                                </DataTable>
                            </div>
                        </div>
                    </TabPanel>
                    <TabPanel header={<div style={{color: 'red'}}>Onay Bekleyen Kredi Talepleri ({pendingApplications.length})</div>}>
                        <div className="datatable-responsive-demo">
                            <div className='card'>
                                <DataTable
                                    value={pendingApplications}
                                    className='p-datatable-responsive-demo'
                                    paginator rows={10}
                                    emptyMessage="Kayıt Bulunamadı"
                                    globalFilter={globalFilter1}
                                    header={customer1TableHeader}
                                >
                                    <Column
                                        field={'sact_id'}
                                        header="Durum"
                                        body={actionTemplate}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'user_name'}
                                        header="Kullanıcı Adı"
                                        body={getApplicationBody("user_name", "Kullanıcı Adı")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'user_inst'}
                                        header="Kurumu"
                                        body={getInstBody("user_inst", "Kurumu")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'reason'}
                                        header="Talep Açıklaması"
                                        body={getDescriptionBody("reason", "Talep Açıklaması")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'application_time'}
                                        header="Başvuru Zamanı"
                                        body={getApplicationBody("application_time", "Başvuru Zamanı")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'requested_credit'}
                                        header="Talep Edilen Kredi"
                                        body={getApplicationBody("requested_credit", "Talep Edilen Kredi")}
                                        style={{textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column
                                        field={'available_credit'}
                                        header="Mevcut Kredi"
                                        body={getApplicationBody("available_credit", "Mevcut Kredi")}
                                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}
                                    />
                                    <Column header="İşlevler"
                                            body={processBody}
                                            style={{textAlign: 'center', width: '5.5em'}}
                                    />

                                </DataTable>

                            </div>

                        </div>

                    </TabPanel>
                </TabView>
                <Dialog visible={acceptDialog}
                        onHide={acceptDialogOnHide}
                        header="Kredi Onayla"
                        style={{width: '75%'}}
                        maximizable
                        dismissableMask
                >
                    <div className="p-grid">
                        <div className="p-col-12 p-sm-12 p-md-6 p-lg-4 p-xl-4">
                            <div className="p-field p-md-3" style={{width: '100%'}}>
                                <label htmlFor="appliedCredit">Kredi Miktarı</label>
                                <InputNumber inputId="appliedCredit"
                                             value={appliedCredit}
                                             onValueChange={(e) => setAppliedCredit(e.value)}
                                             mode="decimal"
                                             style={{width: '100%'}}
                                />
                            </div>
                        </div>
                        <Divider align="left">
                            <div className="p-d-inline-flex p-ai-center">
                                <b>Kredi Limiti</b>
                            </div>
                        </Divider>
                        <div className="p-col-12 p-sm-12 p-md-6 p-lg-3 p-xl-3">
                            <div className="p-field p-md-3" style={{width: '100%'}}>
                                <label htmlFor="cpuLimit">CPU Limiti</label>
                                <InputNumber inputId="cpuLimit"
                                             value={cpuLimit}
                                             onValueChange={(e) => setCpuLimit(e.value)}
                                             mode="decimal"
                                             style={{width: '100%'}}
                                />
                            </div>

                        </div>
                        <div className="p-col-12 p-sm-12 p-md-6 p-lg-3 p-xl-3">
                            <div className="p-field p-md-3" style={{width: '100%'}}>
                                <label htmlFor="gpuLimit">GPU Limiti</label>
                                <InputNumber inputId="gpuLimit"
                                             value={gpuLimit}
                                             onValueChange={(e) => setGpuLimit(e.value)}
                                             mode="decimal"
                                             style={{width: '100%'}}
                                />
                            </div>

                        </div>
                        <div className="p-col-12 p-sm-12 p-md-6 p-lg-3 p-xl-3">
                            <div className="p-field p-md-3" style={{width: '100%'}}>
                                <label htmlFor="ramLimit">RAM Limiti (GB)</label>
                                <InputNumber inputId="ramLimit"
                                             value={ramLimit}
                                             onValueChange={(e) => setRamLimit(e.value)}
                                             mode="decimal"
                                             style={{width: '100%'}}
                                />
                            </div>

                        </div>
                        <div className="p-col-12 p-sm-12 p-md-6 p-lg-3 p-xl-3">
                            <div className="p-field p-md-3" style={{width: '100%'}}>
                                <label htmlFor="diskLimit">DİSK Limiti (GB)</label>
                                <InputNumber inputId="diskLimit"
                                             value={diskLimit}
                                             onValueChange={(e) => setDiskLimit(e.value)}
                                             mode="decimal"
                                             style={{width: '100%'}}
                                />
                            </div>
                        </div>
                        <Divider align="left">
                            <div className="p-d-inline-flex p-ai-center">
                                <b>Talep Onay Açıklaması</b>
                            </div>
                        </Divider>
                        <div className="p-col-12">
                            <div className="p-field p-md-4" style={{width: '100%'}}>
                                <span className="p-float-label">
                                    <InputTextarea id="acceptedDescription" value={creditAcceptedDescription}
                                                   onChange={(e) => setCreditAcceptedDescription(e.target.value)}
                                                   rows={3}
                                                   style={{width: '100%'}}
                                    />
                                    <label htmlFor="acceptedDescription">Kredi Onay Açıklaması</label>
                                </span>
                            </div>
                        </div>
                        <div className="p-col-12" align="right">
                            <Button label="Onayla"
                                    className="p-button-success"
                                    icon="pi pi-check"
                                    onClick={(e) => approve_credit()}/>
                        </div>
                    </div>
                </Dialog>

                <Dialog visible={rejectDialog}
                        onHide={rejectDialogOnHide}
                        header="Kredi İptal Et"
                        style={{width: '75%'}}
                        maximizable
                        dismissableMask
                >
                    <div className="p-grid">
                        <div className="p-col-12">
                            <div className="p-field p-md-4 p-mt-5" style={{width: '100%'}}>
                                <span className="p-float-label">
                                    <InputTextarea id="rejectedDescription" value={creditRejectedDescription}
                                                   onChange={(e) => setCreditRejectedDescription(e.target.value)}
                                                   rows={3}
                                                   style={{width: '100%'}}
                                    />
                                    <label htmlFor="rejectedDescription">Kredi İptal Açıklaması</label>
                                </span>
                            </div>
                        </div>
                        <div className="p-col-12" align="right">
                            <Button label="İptal Et"
                                    className="p-button-danger"
                                    icon="pi pi-times"
                                    onClick={(e) => reject_credit()}/>
                        </div>
                    </div>
                </Dialog>

                <Dialog visible={descriptionDialog}
                        onHide={descriptionDialogOnHide}
                        header={descriptionDialogHeader}
                        style={{width: '75%'}}
                        dismissableMask
                >
                    <div className="p-grid">
                        <div className="p-col-12">
                            {descriptionDialogContent}
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    } else {
        return (
            window.location.hash = "/notfound"
            // <Redirect to="#notfound"/>
        )
    }


}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CreditApplications);



// WEBPACK FOOTER //
// ./src/pages/systemmanagement/CreditApplications.jsx